import React from 'react';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import TimeInput from '@zvuk-b2b/react-uikit/ui/TimeInput';
import { InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import { TEXTS } from '../../../texts';
import { TIME_PATTERN } from '../../../consts';
import { formatMillisecondsToTime } from '../../../utils';
import { defaultTimeInputWithSecondsValidator } from '../utils';

interface ImageDurationControlProps {
  playDuration?: number | null;
  isValid: boolean;
  isBlockedDurationEdit: boolean;
  onBlur: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onChange: (durationString: string) => void;
}

const ImageDurationControl: React.FC<ImageDurationControlProps> = ({
  playDuration,
  isValid,
  isBlockedDurationEdit,
  onBlur,
  onChange,
}) => (
  <Popper
    placement={HintPlacement.PLACEMENT_TOP_START}
    offset={[10, 10]}
    isShow={isBlockedDurationEdit}
    triggerNode={
      <div>
        <TimeInput
          elementId="image_duration_input"
          value={formatMillisecondsToTime(playDuration)}
          inputValidator={defaultTimeInputWithSecondsValidator}
          type={InputType.TEXT}
          forceError={!isValid}
          isDisabled={isBlockedDurationEdit}
          onBlur={onBlur}
          onChange={onChange}
          defaultValue={formatMillisecondsToTime(playDuration)}
          pattern={TIME_PATTERN}
          mask={TEXTS.TIME_MASK}
          placeholder={TEXTS.TIME_PLACEHOLDER}
          maxLength={8}
        />
      </div>
    }>
    {TEXTS.BLOCK_EDIT_WARNING}
  </Popper>
);

export default ImageDurationControl;
